module.exports = require('./helpers/bundle-url').getBundleURL('cNbFg') + "logo.c51670a8.svg";